// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import logo from "../image/hifi.png";
// import registerImg from "../image/Registerimage.png";
// import Footer from "./footer";
// import { Link } from "react-router-dom";

// const Login = () => {
//   return (
//     <div
//       className="container-fluid px-3 px-md-5"
//       style={{ backgroundColor: "#0d0e13", minHeight: "100vh" }}
//     >
//       <>
//         <div className="container-fluid px-3 px-md-5" style={{ backgroundColor: "#0d0e13", minHeight: "100vh" }} >

//           <div class="container-fluid p-3">
//             <nav
//               class="custom-navbar d-flex align-items-center justify-content-between"
//             >
//               {/* <!-- Logo --> */}
//               <div class="logo">
//                 <img src={logo} alt="Logo" />
//               </div>

//               {/* <!-- Right Menu --> */}
//               <div class="d-flex align-items-center">
//                 <button class="connect-wallet-btn">Back</button>
//               </div>
//             </nav>
//           </div>
//           <section
//             class="register-page d-flex align-items-center justify-content-center"
//           >
//             <div class="register-box">
//               <h2 class="register-title">Login</h2>

//               <form>
//                 <div class="register-group">
//                   <label class="register-label">Referral Link</label>
//                   <input
//                     type="text"
//                     class="register-input"
//                     placeholder="Please enter referral link"
//                   />
//                 </div>

//                 <div class="register-group">
//                   <label class="register-label">Address</label>
//                   <input
//                     type="text"
//                     class="register-input"
//                     placeholder="Please enter address"
//                   />
//                 </div>

//                 <button type="submit" class="register-btn">Submit</button>
//               </form>

//               <Link
//                 to="/connect_wallet"
//                 class="register-login">
//                 Already Registered?
//                 <a >Connect Wallet</a> to Continue
//               </Link>
//             </div>
//           </section>
//           <footer class="site-footer">
//             <div class="container text-center">
//               {/* <!-- Logo --> */}
//               <div class="footer-logo mb-3">
//                 <img src={logo} alt="hifi Logo" />
//               </div>

//               {/* <!-- Divider --> */}
//               <div class="footer-divider"></div>

//               {/* <!-- Text --> */}
//               <div class="footer-text">
//                 © 2025 Hifi Internationals | All Rights Reserved.
//               </div>
//             </div>
//           </footer>
//         </div>
//       </>
//       {/* Footer (optional – remove if not needed) */}
//       <Footer />
//     </div>
//   );
// };

// export default Login;


import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import registerImg from "../image/hifi.png";
import Footer from "./footer";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../api/protectedApi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const [walletAddress, setWalletAddress] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!walletAddress) return toast.error("Please enter wallet address");

    const res = await loginUser(walletAddress);

    if (res.status) {
      localStorage.setItem("auth_token", res.token);
      localStorage.setItem("isAuthenticated", "true");
      toast.success("Login successful");
      navigate("/dashboard");
    } else {
      toast.error(res.message || "Login failed");
    }
  };

  return (
    <div
      className="container-fluid px-3 px-md-5"
      style={{ backgroundColor: "#0d0e13", minHeight: "100vh" }}
    >
      <Container className="py-5">
        <Row className="justify-content-center align-items-center gy-5">
          <Col xs={12} md={6} className="text-center">
            <img
              src={registerImg}
              alt="Register Illustration"
              className="img-fluid"
              style={{ maxWidth: "90%" }}
            />
          </Col>

          <Col xs={12} md={6}>
            <div
              className="p-4 rounded"
              style={{ backgroundColor: "#0d0e13", maxWidth: "512px", margin: "0 auto" }}
            >
              <h4 className="fw-bold mb-4 text-white text-center text-md-start">
                Connect Wallet or View Account
              </h4>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label className="text-white">Wallet Address</Form.Label>
                  <Form.Control
                    type="text"
                    value={walletAddress}
                    onChange={(e) => setWalletAddress(e.target.value)}
                    placeholder="Please enter wallet address"
                    style={{
                      backgroundColor: "#474d6eff",
                      border: "none",
                      color: "#fff",
                      padding: "12px",
                      borderRadius: "6px",
                    }}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 fw-semibold"
                  style={{ backgroundColor: "#a88756", border: "none", color: "#eee", padding: "12px", borderRadius: "6px" }}
                >
                  Submit
                </Button>

                <p className="mt-3 text-white text-center small">
                  Already Registered?{" "}
                  <Link
                    to="/connect_wallet"
                    className=""
                    style={{ textDecoration: "none", color: "#a88756" }}
                  >
                    Connect Wallet
                  </Link>{" "}
                  to Continue
                </p>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Login;

